module.exports = __webpack_public_path__ + "static/media/tfp_graph.5980e429.png";